<template>
    <div class="zb">
        <el-table border
                  ref="sgtable1"
                  size="mini"
                  :row-style="rowstyle"
                  :data="applys"
                  :height="tableHeight"
                  :header-cell-style="{background:'#eef1f6',color:'#000'}"
                  :highlight-current-row="true">
            <el-table-column  label="编号"  align="center"  prop="i_appid" show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span  >{{scope.row.i_appid==0?'追加':scope.row.i_appid}}</span>
                </template>
            </el-table-column>
            <el-table-column label="申购公司" prop="apply_ent_name" show-overflow-tooltip>  </el-table-column>
            <el-table-column label="申购部门"  prop="depart_name" show-overflow-tooltip> </el-table-column>
            <el-table-column  label="申购人" prop="applicant_name" show-overflow-tooltip> </el-table-column>
            <el-table-column  prop="vc_pzname" label="品种" show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span  v-if="scope.row.i_appid!='合计'" >{{scope.row.vc_pzname}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_bzstyle" label="规格" show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span  v-if="scope.row.i_appid!='合计'" >{{scope.row.vc_bzstyle}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="f_reqnum"　label="需求量">
                <template slot-scope="scope" >
                    <span  v-if="scope.row.i_appid!=0" >{{scope.row.f_reqnum}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="f_num"　label="本次需求量">
                <template slot-scope="scope">
                    <el-input-number style="width: 100%" v-model="scope.row.f_num" v-if="scope.row.i_appid!='合计'&&!edit" @change="changeSgNum(scope.row,scope.$index)" clearable size="mini" :controls="false" :min="0" ></el-input-number>
                    <span v-else>{{scope.row.f_num}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_unit" label="单位"></el-table-column>
            <el-table-column  prop="vc_reqnote" label="需求说明"></el-table-column>
            <el-table-column align="center"  label="申请日期"   prop="apply_date" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="截止日期"  prop="end_date" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="50" align="center">
                <template slot="header" slot-scope="scope" v-if="!edit">
                    <el-button  icon="el-icon-plus"  @click="pzDetail"   size="mini" v-if="!edit" type="text" ></el-button>
                    <!--                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>-->
                </template>
                <template slot-scope="scope" v-if="!edit">
                    <el-button  icon="el-icon-minus" type="text" v-if="scope.row.i_appid!='合计'&&applys.length>2" @click="deletepz(scope.row,scope.$index)"  size="mini"></el-button>
                    <el-button  type="text" v-if="scope.row.i_appid=='合计'" @click="addSg(scope.row,scope.$index)"  size="mini" >追加</el-button>

                </template>
            </el-table-column>
        </el-table>
        <div  class="center">
            <el-button type="primary" @click="save" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="!data.edit">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <el-dialog title="选择品种"
                   :class="baseerp+'div'"
                   width="90%"
                   :visible.sync="dialogTableVisible"
                   :close-on-click-modal="false"
                   :append-to-body="true">
            <pz-list :add="add" @close="closePz"  v-if="dialogTableVisible"></pz-list>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "../../api"
    import {mapActions} from "vuex";
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import PzList from "./TenderPzList";
    export default {
        name: "TenderList",
        components: { PzList,},
        props:{
            data:{
                type:Object,
                required:true
            },
        },
        data() {
            return {

                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                search:'',
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:true,
                tableHeight:0,
                pzsxListData:[],
                dialogTableVisible:false,
                dialogGysVisible:false,
                detailsVisible:false,
                add:{},
                applys:[],
                mid:0,
                edit:false,
                upid:0,
                index:0,
                seeck:false,
                fileId:0,
                dissave:false,
                disup:false,
                flow:false,
                zj:true,
                delapplys:[],
                dialogpublishView:false,
                publishData:{},
            }
        },
        watch:{
            data:{
                handler(){
                    let arr=JSON.parse(JSON.stringify(this.data.applys)),newArr=[],apList=[];
                        let sum=0,f_neednum=0;
                        arr.forEach(a=>{
                            sum+=a.f_num;
                            if(a.i_appid!=0){f_neednum+=a.f_reqnum};
                        });
                    arr.push({
                                i_appid:'合计',
                                i_pzid:arr[0].i_pzid,
                                vc_unit:arr[0].vc_unit,
                                vc_pzname:arr[0].vc_pzname,
                                vc_bzstyle:arr[0].vc_bzstyle,
                                f_num:this.handelNum(sum),
                                f_neednum:f_neednum,
                    })
                    this.applys=[...arr];
                    this.edit=this.data.edit
                },
                immediate:true,
                deep:true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.$nextTick(()=>{
                this.onResize();
            })

            /*if (!this.edit){

            }*/
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h*0.5
                if(this.tableHeight<60)this.tableHeight=60
            },
            rowstyle({row,column,rowIndex,columnIndex}){
                if(row.i_appid=='合计'){
                    return{backgroundColor:'#eef1f6'}
                }
            },
            cancel(){
                this.$emit('close')
            },
            pzDetail(val,index){
                    this.dialogTableVisible=true;
                    this.index=index;
                    this.add={
                        id:this.id,
                        vc_flags: this.data.vc_flags,
                        i_pztype:this.data.i_pztype,
                        applys:this.applys.filter(a=>a.i_appid!='合计'),
                        page:'applys',
                        pzapplys:this.data.pzapplys,
                    }
            },
            handelNum(num,pre=5){
                return Math.round(+num+'e'+pre)/Math.pow(10,pre)
            },
            closePz(type,pzitem){
                this.dialogTableVisible=false;
                if(type=='save'){
                    let arr=this.applys.filter(a=>a.i_appid!='合计'),newArr=[],pos=0,apList=[],copyarr=[];
                    for (let item of pzitem){
                        let pz=item;
                            pz.f_num=item.f_reqnum;
                        if(arr.length==0){
                            arr.push(pz)
                        }else{
                            let obj=arr.findIndex(ap=>ap.i_appid==pz.i_appid);
                            if(obj==-1)arr.push(pz)
                        }
                    };
                    let sum=0,f_neednum=0;
                    arr.forEach(a=>{
                        sum+=a.f_num;
                        if(a.i_appid!=0){f_neednum+=a.f_reqnum};
                    });
                    arr.push({
                        i_appid:'合计',
                        i_pzid:arr[0].i_pzid,
                        vc_unit:arr[0].vc_unit,
                        vc_pzname:arr[0].vc_pzname,
                        vc_bzstyle:arr[0].vc_bzstyle,
                        f_num:this.handelNum(sum),
                        f_neednum:f_neednum,
                    })

                    this.applys=[...arr];
                }

                this.$forceUpdate();
            },
            getSum(row,index){
                let arr=this.applys.filter(ap=>row.i_pzid==ap.i_pzid&&ap.i_appid!=='合计'),sum=0, i=0;
                arr.forEach(a=>{sum+=a.f_num});
                i=this.applys.findIndex(ap=>row.i_pzid==ap.i_pzid&&ap.i_appid=='合计');
                this.applys[i].f_num=this.handelNum(sum);
                this.$forceUpdate()
            },
            deletepz(row,index){
                this.applys.splice(index,1);
                let arr=this.applys.filter(a=>a.i_appid!='合计'),newArr=[],apList=[];
                if(arr.length>1){
                    let sum=0,f_neednum=0;
                    arr.forEach(a=>{
                        sum+=a.f_num;
                        if(a.i_appid!=0){f_neednum+=a.f_reqnum};
                    });
                    arr.push({
                        i_appid:'合计',
                        i_pzid:arr[0].i_pzid,
                        vc_unit:arr[0].vc_unit,
                        vc_pzname:arr[0].vc_pzname,
                        vc_bzstyle:arr[0].vc_bzstyle,
                        f_num:this.handelNum(sum),
                        f_neednum:f_neednum,
                    })

                    this.applys=[...arr];
                    if(row.i_id!=0)this.delapplys.push(row.i_id);
                }


                // this.getSum(row,index)
            },
            changeSgNum(row,index){
                this.$nextTick(()=>{
                    if(row.i_appid!=0&&row.f_num>row.f_reqnum){
                        this.$message.warning('本次需求量不得大于剩余需求量')
                        this.applys[index].f_num=row.f_reqnum;
                        this.$forceUpdate()
                    }else{
                        this.applys[index].f_num=this.handelNum(row.f_num)
                    }
                    this.getSum(row,index)
                });
                // console.log(this.applys)
                this.$forceUpdate()
            },
            addSg(row,index){
                this.applys.splice(index,0,{
                    i_appid:0,
                    i_pzid:row.i_pzid,
                    vc_pzname:row.vc_pzname,
                    vc_bzstyle:row.vc_bzstyle,
                    vc_unit:row.vc_unit,
                    i_id:0,
                    f_num:0,
                    f_reqnum:0,
                })
                // let arr=this.applys.filter(ap=>row.i_pzid==ap.i_pzid&&ap.i_appid!=='合计'),sum=0, i=0;
                // arr.forEach(a=>{sum+=a.f_num});
                // i=this.applys.findIndex(ap=>row.i_pzid==ap.i_pzid&&ap.i_appid=='合计');
                this.getSum(row,index)
            },
            save(){
                let cans=true;
                let arr=this.applys.filter(a=>a.i_appid!='合计'&&a.i_appid!=0);
                if(arr.length>0){
                    for (let pz of this.applys){
                        if(pz.f_num<=0){
                            cans=false
                            break
                        }
                    }
                    if (!cans){
                        this.$message.error('请输入产品数量')
                        return
                    }
                    let applys=JSON.parse(JSON.stringify(this.applys));
                    this.$emit('close',applys,this.delapplys)
                }else{
                    this.$message.error('请选择申购单')
                    return
                }

            },
            addclose(){
                this.dialogTableVisible=false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .zb{
        position: relative;
    }
    .plusBtn{
        position: absolute;
        right: 0;
        top: 0px;
        height: fit-content;margin: 10px 0;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .flex{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    .leftlabel{
        color: #000;
    }
    .mrt10{
        margin-top: 10px;
    }
    .mrl10{
        margin-left: 10px;
    }
    .mr10{
        margin-right: 10px;
    }
    .mrA{
        margin-top: auto;
        margin-bottom: auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .dfjc{
        display: flex;
        justify-content: space-between
    }
    .center{
        text-align: center;
    }
    .cell .el-button{
        padding: unset;
    }
    .el-button i{
        font-size: 18px;
        font-weight: bold;
    }
/deep/{
    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .el-dialog{
        min-width: 420px;
    }
    .el-input-number--mini{
        width: 80px;
    }
    .el-input-number.is-without-controls .el-input__inner{
        padding-left: 0px;
        padding-right: 0px;
    }
    .el-table__expand-icon{
        display: none;
    }
    .el-table__expanded-cell[class*=cell]{
        padding: 5px;
    }
    .el-radio{
        margin-right: 10px;
    }
    .el-dialog{

        margin:0 auto !important;
        margin-top: calc(7% - 40px) !important;
    }
    .el-button i{
        font-size: 18px;
        font-weight: bold;
    }
    .cell .el-button{
        padding: unset;
    }
    .el-form-item--mini.el-form-item{
        margin-bottom: 10px;
    }
}

</style>